<template>
  <q-page>
    <div class="q-pa-md">
      <Breadcrumbs path-name="purchase" path-method="suggest" />
      <SuggestProduct :is-local="false" :can-edit="loginUser.permission && loginUser.permission.Product > 2" />
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import SuggestProduct from './components/SuggestProduct'
  export default {
    name: "SuggestIndex",
    components: { Breadcrumbs, SuggestProduct },
    data() {
      return {
        columns: [
          { name: 'status', align: 'center', label: '是否啟用', field: 'status', sortable: true,},
          { name: 'category', label: '分類', sortable: true },
          { name: 'title', align: 'center', label: '產品名稱', field: 'title', sortable: true },
          { name: 'nickName', label: '物料暱稱', field: 'nick_name', sortable: true },
          { name: 'safeStock', label: '安全庫存', field: 'safe_stock', sortable: true },
          { name: 'stock', label: '庫存', sortable: true },
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
      }
    },
    computed: {
      ...mapGetters(["loginUser"])
    },
    methods: {
      countStockTotal(stockBlock) {
        let count = 0
        stockBlock.map(row => {
         count += parseInt(row.Stock)
        })
        return count
      }
    }
  }
</script>

<style scoped>

</style>
